<template>
  <div class="Manufacturer-info">
    <div class="manufacturer-img"><img :src="manufacturer.img" alt="厂家信息"></div>
    <div class="manufacturer-name">{{ manufacturer.name }}</div>
  </div>
</template>
<script>
export default {
  props: {
    manufacturer: {
      type: Object,
      default: null
    }
  },
  methods: {

  }

}
</script>
<style>
  .Manufacturer-info{
  margin-left: 2px;
  width: 200px;
  height:120px;
  border: 1px solid #dcdcdc;

  }
  .manufacturer-name{
    font-size: 11px;
    line-height: 40px;
  }
  .manufacturer-img img{
    width: 100%;
    height: 80px;
  }
</style>
